// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISocialSchema {
  /** Название социальной сети **/
  name: string;
  /** Тип соцсети (для выставления иконки) **/
  type: EType;
  /** Ссылка на страницу в социальной сети **/
  url: string;
}
export enum EType {
  'Instagram' = 'instagram',
  'Telegram' = 'telegram',
  'Vk' = 'vk',
  'Youtube' = 'youtube',
}
